import { CheckboxInput } from '../baseInputs'

const MarketingConsentKinto = ({ ...rest }) => {
  return (
    <div className="mt-8 text-base-text">
      <CheckboxInput name={'consent'} {...rest}>
        Yes, I would like to receive updates about products & services from
        KINTO
      </CheckboxInput>
      <p className="mt-2">
        We are committed to protecting your data; find out more in our{' '}
        <a
          className="underline"
          href={'https://www.kinto-mobility.co.uk/privacy-policy'}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="consent-click-link"
          data-gt-label={'https://www.kinto-mobility.co.uk/privacy-policy'}
        >
          Privacy Notice
        </a>
        . You may unsubscribe at any time by clicking on the link in each email
        we send to you or by contacting us at{' '}
        <a
          className="underline"
          href={'mailto:DPO@kinto-uk.com'}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="consent-click-link"
          data-gt-label={'mailto:DPO@kinto-uk.com'}
        >
          DPO@kinto-uk.com
        </a>
        .
      </p>
    </div>
  )
}

export default MarketingConsentKinto
